import { render, staticRenderFns } from "./qrBox.vue?vue&type=template&id=3a8186d1&scoped=true&"
import script from "./qrBox.vue?vue&type=script&lang=js&"
export * from "./qrBox.vue?vue&type=script&lang=js&"
import style0 from "./qrBox.vue?vue&type=style&index=0&id=3a8186d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8186d1",
  null
  
)

export default component.exports